/** @format */
import { useEffect, useState } from 'react';

import {
  defaultPasswordPolicy,
  fetchPasswordPolicy,
} from '../utils/passwordPolicy';

export const usePasswordPolicy = () => {
  const [policy, setPolicy] = useState(defaultPasswordPolicy);

  useEffect(() => {
    let cancelled = false;
    fetchPasswordPolicy().then((p) => {
      if (!cancelled) {
        setPolicy((prev) => ({ ...prev, ...p }));
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return policy;
};
